import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Api} from '../../providers/api';
import {NgxSpinnerService} from 'ngx-spinner';
import {humanizeBytes, UploaderOptions, UploadFile, UploadInput, UploadOutput} from 'ngx-uploader';
import {Auth} from '../../providers/auth';
import {medias} from '../../providers/data';

@Component({
  selector: 'app-upload-view',
  templateUrl: './upload-view.component.html',
  styleUrls: ['./upload-view.component.css']
})
export class UploadViewComponent implements OnInit {

  formData: FormData;
  files: UploadFile[];
  uploadInput: EventEmitter<UploadInput>;
  humanizeBytes: Function;
  dragOver: boolean;
  options: UploaderOptions;

  @Output()
  onclose = new EventEmitter();

  @Output()
  crearFrame = new EventEmitter<any>();

  @ViewChild('framefileinput')
  myFileInput: any;

  @Input()
  frame;
  showFileBody = true;
  showTimeBody = false;

  segundos = 0;

  circuito;

  constructor(private api: Api, private spinner: NgxSpinnerService, private auth: Auth) {
    this.options = {concurrency: 10};
    this.files = [];
    this.uploadInput = new EventEmitter<UploadInput>();
    this.humanizeBytes = humanizeBytes;
    this.showFileBody = true;
    this.auth.userCheck(() => {
      this.circuito = this.auth.circuito;
    }, err => {
      this.auth.logout();
    });
  }

  fileOver(event) {
    console.log(event);
  }

  fileLeave(event) {
    console.log(event);
  }

  ngOnInit() {
  }

  closeAgregar() {
    this.uploadInput.emit({type: 'cancelAll'});
    this.onclose.emit();
  }


  onUploadOutput(output: UploadOutput): void {

    if (output.type === 'allAddedToQueue') {
      console.log('Evento');
      this.startUpload();
    } else if (output.type === 'addedToQueue' && typeof output.file !== 'undefined') {
      // add file to array when added
      console.log('addedToQueue');
      this.validateUpload(output);
    } else if (output.type === 'uploading' && typeof output.file !== 'undefined') {
      console.log('uploading');
      // update current data in files array for uploading file
      const index = this.files.findIndex(file =>
        typeof output.file !== 'undefined' && file.id === output.file.id);
      this.files[index] = output.file;
    } else if (output.type === 'removed') {
      console.log('removed');
      // remove file from array when removed
      this.files = this.files.filter((file: UploadFile) => file !== output.file);
    } else if (output.type === 'dragOver') {
      console.log('dragOver');
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
      console.log('dragOut');
      this.dragOver = false;
    } else if (output.type === 'drop') {
      console.log('drop');
      this.dragOver = false;
    } else if (output.type === 'done') {
      console.log(output);
      this.doneUpload(output.file);
    }
  }

  validateUpload(output) {
    console.log(output);
    let type_media = 0;
    medias.forEach((media) => {
      if (media.type === output.file.type) {
        type_media = media.id;
      }
    });
    if (type_media === 0) {
      alert('Tipo de archivo invalido, Solo se permite mp4, jpg y png.');
      this.cancelUpload(output.file.id);
    } else {
      console.log(this.files);
      if (this.files.length === 0) {
        this.files.push(output.file);
      } else {
        alert('Solo puede subir ur archivo por modulo');
      }
    }
  }

  startUpload(): void {
    const headers = this.auth.uploadHeaders();
    const url = this.api.getUrlUpload();
    const event: UploadInput = {
      type: 'uploadAll',
      url: url, // URL to upload file to
      method: 'POST', // method (POST | PUT)
      headers: headers, // custom headers
      data: {
        idCircuito: this.circuito.id
      }
    };

    this.uploadInput.emit(event);
  }

  doneUpload(file) {
    this.files = this.files.filter((f: UploadFile) => false);
    let type_media = 0;
    medias.forEach((media) => {
      if (media.type === file.type) {
        type_media = media.id;
      }
    });
    if (type_media === 0) {
      alert('Tipo de archivo invalido, Solo se permite mp4, jpg y png.');
    } else {
      const res = file.response;
      console.log('respuesta');
      console.log(res);

      if (res && res.data && res.data.filename) {
        this.frame.idMedia = type_media;
        this.frame.path = res.data.filename;
        this.frame.bytes = file.size;
        this.frame.type = file.type;
        this.frame.segundos = res.data.duration ? res.data.duration : 0;
        console.log(this.frame);
        if (type_media === 2) {
          this.showFileBody = false;
          this.showTimeBody = true;
        } else {
          this.crearFrame.emit(this.frame);
        }
      } else {
        alert('Error al subir el archivo');
      }
    }
  }

  crearFrameImagen() {
    this.frame.segundos = this.segundos;
    this.crearFrame.emit(this.frame);
  }

  cancelUpload(id: string): void {
    this.uploadInput.emit({type: 'cancel', id: id});
  }

  removeFile(id: string): void {
    this.uploadInput.emit({type: 'remove', id: id});
  }

  removeAllFiles(): void {
    this.uploadInput.emit({type: 'removeAll'});
  }

  obtenerNombre(filename) {
    const longitud = filename.length - (filename.split('.').pop().length + 1);
    let nombre;
    if (longitud > 0) {
      nombre = filename.substr(0, longitud);
    }
    console.log(filename);
    console.log(nombre);
    return nombre;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/upload-view/upload-view.component.ts